import { AbconetApi } from './AbconetApi';

function isDescendant(parent, child) {
    if (child == null) {
        return false;
    }

    var node = child.parentNode;
    while (node != null) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

var timeoutInstance = null;

export class Search extends React.Component {
    constructor(props) {
        super(props);
        this.formContainerRef = React.createRef();
        this.state = {
            term: "",
            resultCollection: [],
            showResultCollection: false
        };
    }

    onFocus() {
        this.setState({
            showResultCollection: true
        });
    }

    onBlur(ev) {
        if (!isDescendant(this.formContainerRef.current, ev.relatedTarget)) {
            setTimeout(() => {
                    this.setState({
                        showResultCollection: false
                    });
                },
            50);
        }
    }

    onSearchResultClick(result, searchPosition) {
        console.log('on search result click');
        fetch('https://api.addsearch.com/v1/stats/f4b5a323b877338c5ab9b5689483c54c/',
            {
                method: 'POST',
                body: JSON.stringify(
                    {
                        "action": "click",
                        "session": this.props.sessionId,
                        "keyword": this.state.term,
                        "docid": result.searchHit.id,
                        "position": searchPosition
                    }),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

        this.setState({ resultClicked: true });
    }

    renderResult(result, searchPosition) {
        return (
            <a key={"search-result-" + result.stockcode} href={result.url} className="search-result-item" onClick={this.onSearchResultClick.bind(this, result, searchPosition)}>
                <img src={result.imageFileName}/>
                <div className="meta">
                    <span className="name">{result.name}</span>
                    <span className="stockcode">{result.stockcode}</span>
                </div>
            </a>
        );
    }

    renderMoreButton() {
        if (this.state.resultCollection.length >= 5) {
            return <button className="btn btn-primary">View all</button>;
        }
    }

    renderSearchResults() {
        if (this.state.showResultCollection === false || this.state.resultCollection.length === 0) {
            return;
        }
        var searchInfo = [];

        for (var i = 0; i < this.state.resultCollection.length; i++) {
            var result = this.state.resultCollection[i];
            console.log('result data', result);
            searchInfo.push(this.renderResult(result, i+1));
        }

        console.log('render search results', searchInfo);

        return <div className="search-result-collection">
                    {searchInfo}
                    {this.renderMoreButton()}
               </div>;
    }

    handleChange(ev) {
        if (this.state.abortController != null) {
            this.state.abortController.abort();
        }

        if (timeoutInstance != null) {
            clearTimeout(timeoutInstance);
        }

        var self = this;
        var abortController = new AbortController();
        this.setState({ term: ev.target.value, abortController: abortController });
        timeoutInstance = setTimeout(() => {

                AbconetApi.get(`/api/product/?term=${self.state.term}&itemsPerPage=5`, abortController.signal).then(
                    (data) => {
                        self.setState({
                            resultCollection: data,
                            abortController: null
                        });
                       
                        dataLayer.push({
                            event: 'search',
                            search_term: this.state.term,
                        });
                    }).catch(() => {

                });
            },
            200);

    }

    render() {
        return (
            <form className="form-search flex-fill" action="/search/" ref={this.formContainerRef}>
                <div className="input-group">
                    <div className="d-flex search">
                        <input className="form-control search__input" name="term" type="text" value={this.state.term} onChange={this.handleChange.bind(this)} placeholder="Search products" aria-label="Search" onFocus={this.onFocus.bind(this)} onBlur={this.onBlur.bind(this)}  />
                        <button type="submit" className="btn search__icon"><i className="icon icon-search"></i></button>
                    </div>
                </div>
                {this.renderSearchResults()}

            </form>
            );
    }
}